module.exports = __webpack_public_path__ + "static/media/max-schultz-lose.89ceae48.png";